/** @jsxImportSource @emotion/react */
import React from 'react';
import UDFormInput from 'ud-form/components/input';
import type { DivProps } from '../../../../../../typings';
import Label from '../label/label';
import * as S from './styles';

interface IProps extends DivProps {
  icon?: React.ReactNode;
  label?: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  loading?: boolean;
}

function Field(props: IProps) {
  const { icon, label, name, placeholder, disabled = false, loading, ...rest } = props;

  return (
    <S.MainBlock {...rest} disabled={disabled}>
      {(label || icon) && (
        <Label icon={icon} className="mb-1">
          {label}
        </Label>
      )}
      {loading ? (
        <div className="skeleton-block" style={{ width: '100%', height: 36 }} />
      ) : (
        <UDFormInput disabled={disabled} errorVisible name={name} placeholder={placeholder} />
      )}
    </S.MainBlock>
  );
}

export default Field;
